import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'permission-info',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './permission-info.component.html',
  styleUrl: './permission-info.component.css',
})
export class PermissionInfoComponent {
  // nullの場合はアイコンのみ表示（テキストなし）
  @Input() triggerLabel: string | null = '権限について';
  // アイコンのサイズ（px）
  @Input() iconSize = 18;
  public isOpen = false;

  toggle() {
    this.isOpen = !this.isOpen;
  }
}
